
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// React 渲染完成後通知隱藏載入指示器（但會確保最小顯示時間）
if (typeof window !== 'undefined' && (window as any).hideLoadingScreen) {
  (window as any).hideLoadingScreen();
}
